import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class BrandService {
  private favIcon: HTMLLinkElement = document.querySelector('#fav-icon');

  constructor(private titleService: Title, private translate: TranslateService) { }

  setTitle(id: number, brand: string) {
    if (id == 374)
    {
      this.favIcon.href = 'favReevesIcon.ico';
    }
    else
    {
      this.favIcon.href = 'favicon' + id + '.ico';
    }
 
    this.titleService.setTitle(brand);
  }

  checkBrand(param: Params): number {
    var brandId = window.location.hostname === "localhost" ? 543 : 373;
    if (param.brand) {
      switch (param.brand) {
        case "cdi":
        case "cdi-college":
        case "college-cdi": {
          brandId = 373;
          break;
        }
        case "pcu": {
          brandId = 375;
          break;
        }
        case "rvs": {
          brandId = 374;
          break;
        }
        case "vacc": {
          brandId = 372;
          break;
        }
        case "vcad": {
          brandId = 543;
          break;
        }
        case "tkc": {
          brandId = 500;
          break;
        }
        default: {
          brandId = 373;
          break;
        }
      }
    } else {
      switch (window.location.hostname) {
        case "app.cdicollege.ca":
        case "book.cdicollege.ca":
        case "book.cdicollege.info":
        case "book.collegecdi.ca":
        case "book.collegecdi.info": {
          brandId = 373;
          break;
        }
        case "pcu": {
          brandId = 375;
          break;
        }
        case "app.reevescollege.ca":
        case "book.reevescollege.ca":
        case "book.reevescollege.info": {
          brandId = 374;
          break;
        }
        case "app.career.college":
        case "book.career.college":
        case "book.collegecareer.info": {
          brandId = 372;
          break;
        }
        case "app.vcad.ca":
        case "book.vcad.ca":
        case "book.vcad.info": {
          brandId = 543;
          break;
        }
        case "book.tkconline.ca":
        case "book.tkconline.com":
        case "book.tkconline.info": {
          brandId = 500;
          break;
        }
        case "localhost": {
          brandId = 543;
          break;
        }
        default: {
          brandId = 373;
          break;
        }
      }
    }
    //brandId = 543;  // When you want to debug VCAD college = book.vcad.info
    return brandId;
  }

  inFrench(): boolean {
    switch (window.location.hostname) {
      case "book.collegecdi.ca":
      case "book.collegecdi.info": {
        this.translate.use("fr");
        return true;
      }
      default: {
        this.translate.use("en");
        return false;
      }
    }
  }
}
